import React from "react";
import Navbar from "../components/site/Navbar";
import Seo from "../seo/Seo";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Invite from "../components/site/Invite";
import Portfolio from "../components/site/Portfolio";
import Process from "../components/site/Process";
import Testimonials from "../components/site/Testimonials";
import Media from "../components/site/Media";
import Books from "../components/site/Books";
import Gallery from "../components/site/Gallery";
import BlogSection from "../components/site/BlogSection";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <div className="bg-obsidian min-h-screen">
      <Seo
        title="Amiran Azaladze — Entrepreneur, Founder & Investor"
        description="Amiran Azaladze is an entrepreneur and business leader — founder of B2B Hub, Astra Terminal, FX Astra and Dezinfector, and author of 'Forex — 6 Steps to Financial Independence'. Building SaaS, fintech and service ventures worldwide."
        path="/"
      />
      <Navbar />
      <Hero />
      <About />
      <Invite />
      <Portfolio />
      <Process />
      <Testimonials />
      <Media />
      <Books />
      <Gallery />
      <BlogSection />
      <Contact />
      <Footer />
    </div>
  );
}
